import { useState, useCallback } from 'react';
import { getDocs, collection } from 'firebase/firestore';
import { db } from '../../firebase';
import AdminEditUser from './AdminEditUser';

async function fetchAllUsers() {
  const snap = await getDocs(collection(db, 'usersByEmail'));
  return snap.docs.map(d => d.data());
}

function AdminUserList() {
  const [users, setUsers]           = useState(null);
  const [loading, setLoading]       = useState(false);
  const [search, setSearch]         = useState('');
  const [selectedUser, setSelectedUser] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setUsers(await fetchAllUsers());
    } finally {
      setLoading(false);
    }
  }, []);

  const filtered = users
    ? users.filter(u => u.email?.toLowerCase().includes(search.toLowerCase()))
    : [];

  if (selectedUser) {
    return <AdminEditUser user={selectedUser} onBack={() => setSelectedUser(null)} />;
  }

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        <input
          type="text"
          placeholder="Filter by email…"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onFocus={() => !users && !loading && load()}
          style={{
            flex: 1, padding: '9px 12px', border: '1.5px solid #E5E7EB',
            borderRadius: 8, fontSize: 13, outline: 'none', fontFamily: 'inherit',
          }}
        />
        <button
          onClick={load}
          disabled={loading}
          style={{
            padding: '9px 14px', borderRadius: 8, border: 'none',
            background: '#0A7C8A', color: '#fff', fontWeight: 700,
            cursor: loading ? 'not-allowed' : 'pointer', fontSize: 13,
          }}
        >
          {loading ? '…' : 'Refresh'}
        </button>
      </div>

      {users === null && !loading && (
        <div style={{ textAlign: 'center', color: '#9CA3AF', fontSize: 13, padding: '20px 0' }}>
          Click Refresh or focus the search field to load users.
        </div>
      )}

      {loading && (
        <div style={{ textAlign: 'center', color: '#9CA3AF', fontSize: 13, padding: '20px 0' }}>
          Loading…
        </div>
      )}

      {users && !loading && (
        <>
          <div style={{ fontSize: 11, color: '#9CA3AF', marginBottom: 10 }}>
            {filtered.length} of {users.length} user{users.length !== 1 ? 's' : ''}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {filtered.length === 0 && (
              <div style={{ textAlign: 'center', color: '#9CA3AF', fontSize: 13 }}>No users match.</div>
            )}
            {filtered.map(u => (
              <div
                key={u.uid}
                onClick={() => setSelectedUser(u)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10,
                  padding: '12px 14px', border: '1.5px solid #E5E7EB', borderRadius: 10,
                  cursor: 'pointer', background: '#fff',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = '#0A7C8A'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = '#E5E7EB'; }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: '#111', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {u.email}
                  </div>
                  {u.displayName && (
                    <div style={{ fontSize: 11, color: '#9CA3AF' }}>{u.displayName}</div>
                  )}
                </div>
                <div style={{ fontSize: 12, color: '#0A7C8A', flexShrink: 0 }}>Edit →</div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export default AdminUserList;
